module.exports = "pegasus_template/assets/col_2.png";